// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"69c53dffcab17025ed31","293":"ee2d308146e71fcb5a57","518":"838f0af0bbf37a39a02c","779":"1b4e6f67d5895f605871"}[chunkId] + ".js";
};